import { Injectable } from '@angular/core';
import { concat, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { FullClientInterface } from '../data';
import { TestProvider } from '../providers/test.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface UploadTestDocumentsUseCaseParams {
    client: FullClientInterface;
    documents: File[];
}

@Injectable()
export class UploadTestDocumentsUseCase implements UseCaseWithParam<UploadTestDocumentsUseCaseParams, Observable<Transaction<void>>> {
    constructor(private testProvider: TestProvider) {}

    bind(params: UploadTestDocumentsUseCaseParams): Observable<Transaction<void>> {
        return new Observable((observer) => {
            const observables: Observable<Transaction<void>>[] = [];

            if (params.documents) {
                params.documents.map((document) => {
                    observables.push(
                        this.testProvider.upload(params.client.encryptedCode, document).pipe(
                            map((transaction) => {
                                if (!transaction.isSuccess) {
                                    throw new Error(transaction.error);
                                }

                                return transaction;
                            })
                        )
                    );
                });
            }

            concat(...observables).subscribe({
                error: (err: Error) => {
                    observer.next(Transaction.error(err.message));
                    observer.complete();
                },
                complete: () => {
                    observer.next(Transaction.success());
                    observer.complete();
                },
            });
        });
    }
}
